import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppContext } from "src/context/AppContext";
import { useAuth0 } from "src/hooks/useAuth";
import { usePermissions } from "src/hooks/usePermissions";
import { RequestCounts } from "../types";
import { apiClient } from "src/api/apiService";
import { getNavConstants } from "../helpers";

export function useNavSection() {
  const [counts, setCounts] = useState<RequestCounts>({});
  const location = useLocation();
  const { isAuthenticated, logout } = useAuth0();
  const { hasViewAllRequestsPermissions, hasCreateRequestPermissions } =
    usePermissions();
  const {
    context: { user, featureFlags },
  } = useContext(AppContext);

  const navContent = getNavConstants(
    hasViewAllRequestsPermissions,
    hasCreateRequestPermissions,
    featureFlags.openChangeRequests
  );

  const fetchRequestCounts = async () => {
    try {
      const response = await apiClient.get<RequestCounts>("/request/counts");
      setCounts(response.data);
    } catch (error) {
      console.log(`Fetch request counts error: ${error}`);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchRequestCounts();
    }
  }, [location.pathname, isAuthenticated]);

  return { counts, user, navContent, location, logout, isAuthenticated };
}
